import React, { useMemo } from 'react'
import { CustomRule } from 'devextreme-react/data-grid'
import numberFormatter from '../../../../../helpers/numberFormatter'

const useCategorizedColumn = (categories, changedArray, setChangedArray, visibleCols, displayedColumn, tableData, t, fieldName, locale)=> {
	return useMemo(() => categories.map((item, i) => {
		const isRecordSelected = id => changedArray.indexOf(id) !== -1
		if(visibleCols[item]) {
			const isSelected = isRecordSelected(i)
			setChangedArray(idArr => isSelected ? idArr.filter(recordId => recordId !== i) : [...idArr, i])
		}
		if(displayedColumn[item]) {
			const capitalizeName = 'new' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
			return [
				{
					caption: item,
					dataField: `${fieldName}[${i}]`,
					idx: i,
					allowEditing: false,
					width: 100,
					localFormat: { type: 'float', precision: 2 }
				},
				{
					caption: `${item} (B)`,
					dataField: capitalizeName,
					customizeText: cell => Array.isArray(cell?.value) && (numberFormatter(cell?.value?.[i], { locale }) || ''),
					idx: i,
					name: `${capitalizeName}[${i}]`,
					cssClass: 'cell-colored',
					alignment: 'right',
					children: () => (
						<CustomRule
							type='custom'
							ignoreEmptyValue={false}
							message={t('validators.invalid_value')}
							validationCallback={info => {
								if(typeof info?.value === 'string') {
									if(+info?.value !== 0) {
										return true
									}
									return false
								} else if(Array.isArray(info?.value)) {
									if(info?.value[i] !== 0) {
										return true
									}
									return false
								}
								return true
							}}
						/>
					)
				}
			]
		}
		return null
	}).flat().filter(item => item), [displayedColumn, visibleCols, tableData])
}
export default useCategorizedColumn
